import React from 'react'

import PresenterInfo from './PresenterInfo'

const WelcomePage = props => {
  const clientName = localStorage.getItem('clientName')

  let superHeadline
  let heading
  let backgroundImage

  if (props) {
    superHeadline = props.superHeadline
    heading = props.heading
    backgroundImage = props.backgroundImage
  }

  return (
    <div
      className='welcome-wrapper u-flex u-flexJustifyCenter'
      style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className='welcome-content-wrapper'>
        <div className='u-pt-hidden Grid Grid--alignCenter u-paddingBottom8gu'>
          <h1 className='u-textSecondary u-marginBottom10gu u-textColorWhite u-textSizeMsrp7'>
            {superHeadline}
          </h1>
        </div>
        <h2 className='welcome-subhead u-textPrimary u-textSizeMsrp3 u-textColorWhite'>
          {clientName ? `${heading} ${clientName}` : ''}
        </h2>
        <PresenterInfo />
      </div>
    </div>
  )
}

export default WelcomePage
